import { useIntl } from 'react-intl'

export const useRacePrizes = () => {
  const { formatMessage, formatNumber } = useIntl()

  return [
    {
      id: 1,
      title: formatMessage(
        { id: 'promo.rakeRace.prize1' },
        {
          cash: formatNumber(3_000, {
            style: 'currency',
            currency: 'USD',
            maximumFractionDigits: 0,
          }),
        },
      ),
      prize: 4548,
    },
    {
      id: 2,
      title: formatMessage(
        { id: 'promo.rakeRace.prize1' },
        {
          cash: formatNumber(2_000, {
            style: 'currency',
            currency: 'USD',
            maximumFractionDigits: 0,
          }),
        },
      ),
      prize: 3548,
    },
    {
      id: 3,
      title: formatMessage(
        { id: 'promo.rakeRace.prize1' },
        {
          cash: formatNumber(1_000, {
            style: 'currency',
            currency: 'USD',
            maximumFractionDigits: 0,
          }),
        },
      ),
      prize: 2548,
    },
    {
      id: 4,
      title: formatMessage({ id: 'promo.rakeRace.prize2' }),
      prize: 1548,
    },
    {
      id: 5,
      title: formatMessage({ id: 'promo.rakeRace.prize2' }),
      prize: 1548,
    },
    {
      id: 6,
      title: formatMessage({ id: 'promo.rakeRace.prize3' }),
      prize: 828,
    },
    {
      id: 7,
      title: formatMessage({ id: 'promo.rakeRace.prize3' }),
      prize: 828,
    },
    {
      id: 8,
      title: formatMessage({ id: 'promo.rakeRace.prize3' }),
      prize: 828,
    },
    {
      id: 9,
      title: formatMessage({ id: 'promo.rakeRace.prize3' }),
      prize: 828,
    },
    {
      id: 10,
      title: formatMessage({ id: 'promo.rakeRace.prize3' }),
      prize: 828,
    },
    {
      id: 11,
      title: formatMessage({ id: 'promo.rakeRace.prize4' }),
      prize: 149,
    },
    {
      id: 12,
      title: formatMessage({ id: 'promo.rakeRace.prize4' }),
      prize: 149,
    },
    {
      id: 13,
      title: formatMessage({ id: 'promo.rakeRace.prize4' }),
      prize: 149,
    },
    {
      id: 14,
      title: formatMessage({ id: 'promo.rakeRace.prize4' }),
      prize: 149,
    },
    {
      id: 15,
      title: formatMessage({ id: 'promo.rakeRace.prize4' }),
      prize: 149,
    },
    {
      id: 16,
      title: formatMessage({ id: 'promo.rakeRace.prize4' }),
      prize: 149,
    },
    {
      id: 17,
      title: formatMessage({ id: 'promo.rakeRace.prize4' }),
      prize: 149,
    },
    {
      id: 18,
      title: formatMessage({ id: 'promo.rakeRace.prize4' }),
      prize: 149,
    },
    {
      id: 19,
      title: formatMessage({ id: 'promo.rakeRace.prize4' }),
      prize: 149,
    },
    {
      id: 20,
      title: formatMessage({ id: 'promo.rakeRace.prize4' }),
      prize: 149,
    },
    {
      id: 21,
      title: formatMessage({ id: 'promo.rakeRace.prize5' }),
      prize: 89,
    },
    {
      id: 22,
      title: formatMessage({ id: 'promo.rakeRace.prize5' }),
      prize: 89,
    },
    {
      id: 23,
      title: formatMessage({ id: 'promo.rakeRace.prize5' }),
      prize: 89,
    },
    {
      id: 24,
      title: formatMessage({ id: 'promo.rakeRace.prize5' }),
      prize: 89,
    },
    {
      id: 25,
      title: formatMessage({ id: 'promo.rakeRace.prize5' }),
      prize: 89,
    },
    {
      id: 26,
      title: formatMessage({ id: 'promo.rakeRace.prize5' }),
      prize: 89,
    },
    {
      id: 27,
      title: formatMessage({ id: 'promo.rakeRace.prize5' }),
      prize: 89,
    },
    {
      id: 28,
      title: formatMessage({ id: 'promo.rakeRace.prize5' }),
      prize: 89,
    },
    {
      id: 29,
      title: formatMessage({ id: 'promo.rakeRace.prize5' }),
      prize: 89,
    },
    {
      id: 30,
      title: formatMessage({ id: 'promo.rakeRace.prize5' }),
      prize: 89,
    },
    {
      id: 31,
      title: formatMessage({ id: 'promo.rakeRace.prize6' }),
      prize: 49,
    },
    {
      id: 32,
      title: formatMessage({ id: 'promo.rakeRace.prize6' }),
      prize: 49,
    },
    {
      id: 33,
      title: formatMessage({ id: 'promo.rakeRace.prize6' }),
      prize: 49,
    },
    {
      id: 34,
      title: formatMessage({ id: 'promo.rakeRace.prize6' }),
      prize: 49,
    },
    {
      id: 35,
      title: formatMessage({ id: 'promo.rakeRace.prize6' }),
      prize: 49,
    },
    {
      id: 36,
      title: formatMessage({ id: 'promo.rakeRace.prize6' }),
      prize: 49,
    },
    {
      id: 37,
      title: formatMessage({ id: 'promo.rakeRace.prize6' }),
      prize: 49,
    },
    {
      id: 38,
      title: formatMessage({ id: 'promo.rakeRace.prize6' }),
      prize: 49,
    },
    {
      id: 39,
      title: formatMessage({ id: 'promo.rakeRace.prize6' }),
      prize: 49,
    },
    {
      id: 40,
      title: formatMessage({ id: 'promo.rakeRace.prize6' }),
      prize: 49,
    },
  ]
}
